import { AxiosResponse } from 'axios';

import apiClient from './client';
import { PageResultDto } from 'interfaces/page';
import { LeadDto } from 'interfaces/lead';
import { ApiResponseDto } from 'interfaces/apiResponse';

interface LeadsService {
  search(queryParams?: any): Promise<PageResultDto<LeadDto>>;
}

const endpoints = {
  search: '/leads',
};

export const leadsService: LeadsService = {
  search: async (queryParams?: any): Promise<PageResultDto<LeadDto>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<LeadDto>>> = await apiClient.get(endpoints.search, {
      params: { ...queryParams },
      paramsSerializer: { indexes: null },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
